exports = module.exports = require("../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".v-spinner .v-moon1\n{\n  animation: v-moonStretchDelay 0.6s 0s infinite linear;\n  animation-fill-mode: forwards;\n  position: relative;\n}\n.v-spinner .v-moon2\n{\n  animation: v-moonStretchDelay 0.6s 0s infinite linear;\n  animation-fill-mode: forwards;\n  opacity: 0.8;\n  position: absolute;\n}\n.v-spinner .v-moon3\n{\n  opacity: 0.1;\n}\n@keyframes v-moonStretchDelay\n{\n100%\n    {\n    transform: rotate(360deg);\n}\n}\n", ""]);

// exports
